<section class="home-final-cta modern-section dingo-section dingo-bg-accent">
  <div class="container">
    <aside class="home-final-cta-card reveal-on-scroll" data-reveal="card">
      <p class="home-section-kicker">Siguiente paso</p>
      <h2>¿Listo para escalar <span class="highlight-green">tu negocio</span>?</h2>
      <div class="section-underline section-underline--left"></div>
      <p>Agenda una sesión estratégica sin costo y descubre cómo generar más clientes con un sistema diseñado para crecer.</p>
      <div class="home-final-cta-actions">
        <a class="dingo-cta-primary" [href]="calendlyPlaceholderUrl" target="_blank" rel="noopener">
          Agendar llamada
          <i class="bi bi-calendar-check"></i>
        </a>
        <a
          class="dingo-cta-secondary"
          href="https://wa.me/5215616635041?text=Hola%2C%20quiero%20un%20diagn%C3%B3stico%20de%20mi%20marca"
          target="_blank"
          rel="noopener"
        >
          Hablar por WhatsApp
          <i class="bi bi-arrow-up-right"></i>
        </a>
      </div>
    </aside>
  </div>
</section>
